import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {SenatorNoGvKeyConfirmationService, SenatorQualityGateService, SenatorService} from '../../../../../api/services';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {SenatorTrades} from '../../../../../api/models/senator-trades';
import {SenatorCompany} from '../../../../../api/models/senator-company';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ShowTradeByIdComponent} from '../show-trade-by-id/show-trade-by-id.component';
import {SenatorQualityGateType} from '../../../../../api/models/senator-quality-gate-type';
import {SenatorNoGvKeyConfirmation} from '../../../../../api/models/senator-no-gv-key-confirmation';
import {SelectionModel} from '@angular/cdk/collections';
import 'rxjs-compat/add/observable/forkJoin';
import {SenatorQualityGateFilterModel} from '../../../../../api/models/senator-quality-gate-filter-model';
import {Router} from '@angular/router';

@Component({
  selector: 'app-no-gvkey-confirmation-mapping',
  templateUrl: './no-gvkey-confirmation-mapping.component.html',
  styleUrls: ['./no-gvkey-confirmation-mapping.component.scss']
})
export class NoGvkeyConfirmationMappingComponent implements OnInit, AfterViewInit {

  @ViewChild(ShowTradeByIdComponent)
  showTradeById: ShowTradeByIdComponent;

  @Input('selectedGateType')
  selectedGateType: string;

  selection = new SelectionModel<SenatorNoGvKeyConfirmation>(true, []);

  twoIQAssetsList: SenatorCompany[] = [];
  // mat table vars
  nonGvkeyConfirmationColumns: string[] = ['companyName', 'tradeCount', 'botNames', 'oldestTradeDate', 'latestTradeDate', 'actions'];
  displayedColumns: string[] = this.nonGvkeyConfirmationColumns;
  issuerTableDataSource: MatTableDataSource<SenatorNoGvKeyConfirmation>;

  processedTypes = ['ALL', 'PROCESSED', 'UNPROCESSED'];
  selectedProcessedType;
  selectedSearchProcessedType;

  pageSize: number;
  pageNumber: number;
  searchPageNumber: number;
  lastPageNumber: number;
  lastSearchPageNumber: number;
  isSearchingIssuerName: boolean;
  searchString: string;
  lastSearchString: string;
  isLastActionSearch: boolean;

  pageSizeOptions: number[] = [10, 20, 50, 100, 200];
  pageEvent: PageEvent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  issuerForm: FormGroup;
  multipleSelectNoGvkeyForm: FormGroup;

  loadingData = false;
  assetNamesLoading: boolean;

  hideFilters = false;

 // private selectedQualityGateType = SenatorQualityGateType.NO_GVKEY_CONFIRMATION;

  constructor(private qualityGateService: SenatorQualityGateService,
              private _senatorService: SenatorService, private senatorService: SenatorService,
              public snackBar: MatSnackBar, private _fb: FormBuilder,
              private changeDetectorRefs: ChangeDetectorRef,
              private router: Router,
              private senatorNoGvKeyConfirmationService: SenatorNoGvKeyConfirmationService) {
  }


  ngOnInit() {
    // console.log('input data selectedGateType: ', this.selectedGateType);
    this.initVars();
    this.getNoGvkeyConfirmationRecords();
  }

  ngAfterViewInit() {
    if (this.issuerTableDataSource != null) {
      this.issuerTableDataSource.paginator = this.paginator;
      this.issuerTableDataSource.sort = this.sort;
    }
  }

  initVars() {
    this.pageSize = 10;
    this.pageNumber = 1;
    this.searchPageNumber = 1;
    this.lastPageNumber = 1;
    this.lastSearchPageNumber = 1;
    this.selectedProcessedType = 'ALL';
    this.selectedSearchProcessedType = 'ALL';
    this.assetNamesLoading = false;
    this.isSearchingIssuerName = false;
    this.searchString = '';
    this.lastSearchString = '';
    this.isLastActionSearch = false;
    this.createMultipleSelectNoGvkeyForm();
  }

  createMultipleSelectNoGvkeyForm() {
    this.multipleSelectNoGvkeyForm = this._fb.group({
      'multiselectNew2iqAssetName': [null, Validators.required],
      'multiselectGvkey': [null, Validators.required],
      'multiselectPermid': [],
    });
  }

  getNoGvkeyConfirmationRecords(value?: string) {
   /* if (this.isSearchingIssuerName)
      value = this.searchString;
    this.loadingData = true;

    const params: SenatorQualityGateFilterModel = {
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      processedType: this.selectedProcessedType == 'ALL' ? 'ALL' :
        this.selectedProcessedType == 'PROCESSED' ? 'PROCESSED' : 'UNPROCESSED',
      qualityGateType: this.selectedQualityGateType,
      searchByCompanyName: value,

    };
    this.senatorNoGvKeyConfirmationService.getSenatorNoGvKeyConfirmation(params).subscribe(
      (res: SenatorNoGvKeyConfirmation[]) => {
        this.issuerTableDataSource = new MatTableDataSource<SenatorNoGvKeyConfirmation>(res);
        //  console.log('issuerTableDataSource res', res);

      },
      error => {
        this.loadingData = false;
      },
      () => {
        this.loadingData = false;
        this.paginator.pageIndex = this.pageNumber - 1;
        this.paginator.pageSize = this.pageSize;
        this.displayedColumns = this.nonGvkeyConfirmationColumns;
        this.hideFilters = false;
      }
    );*/
  }

  onProcessClick(row: SenatorNoGvKeyConfirmation, action: string) {
    console.log(' onSaveClick --> row', row);
    row.isProcessed = true;
    switch (action) {
      case  'Process':
        row.isProcessed = true;
        break;
      case  'UnProcess':
        row.isProcessed = false;
        break;
    }
    const params: SenatorNoGvKeyConfirmation = row;
    this.senatorNoGvKeyConfirmationService.updateSenatorNoGvKeyConfirmation(params).subscribe(
      (res: SenatorNoGvKeyConfirmation) => {
      },
      err => {
        this.loadingData = false;
        this.openSnackBar(err.error.message, 'Close');
      },
      () => {
        this.loadingData = false;
        this.paginator.pageIndex = this.pageNumber - 1;
        this.paginator.pageSize = this.pageSize;

        this.displayedColumns = this.nonGvkeyConfirmationColumns;
        this.hideFilters = false;
        this.openSnackBar(`Issuer has been marked as ${action}`, 'Close');
      }
    );
  }


  searchAssetNames(companyName: string, trade: SenatorTrades) {
    // this.activeRow = trade;
    this.assetNamesLoading = true;
    // console.log('Key up event', name);
    this._senatorService.getSenatorAssetNames(companyName).subscribe((res: SenatorCompany[]) => {
      this.twoIQAssetsList = res;
    }, (err) => {
      this.assetNamesLoading = false;
      // console.log('file update Error', err);
      if (err.status === 400 || err.status === 500) {
        this.openSnackBar('Something went wrong! please enter a valid company name.', 'Close');
      } else {
        this.openSnackBar(err.error.message, 'Close');
      }

    }, () => {
      this.assetNamesLoading = false;
      if (this.twoIQAssetsList.length === 0) {

        this.snackBar.open('No Company found with this name', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });
      }
    });
  }

  mapCompanyWith2IQ(event, company: SenatorCompany, row: any, index: number
  ) {
    if (event.source.selected) {
      (<FormArray>this.issuerForm.controls['issuers']).at(index).get('newGvkey').setValue(company.gvkey);
      (<FormArray>this.issuerForm.controls['issuers']).at(index).get('newPermId').setValue(company.permId);
      // console.log('this.issuers Form: ', this.issuerForm);
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
      horizontalPosition: 'left',
      verticalPosition: 'bottom'
    });
  }

  selectionChanged(value: boolean) {
    if (value == false) {
      this.getNoGvkeyConfirmationRecords();
    }
  }

  applySearch(value: string) {
    this.selection.clear();
    if (value.length === 0) {
      //if search removed
      this.isSearchingIssuerName = false;

      if (this.isLastActionSearch) {
        this.lastSearchPageNumber = this.pageNumber;
        this.pageNumber = this.lastPageNumber;
      }
      this.getNoGvkeyConfirmationRecords();
      this.isLastActionSearch = false;
    } else {
      //if searched something
      this.isSearchingIssuerName = true;
      if (!this.isLastActionSearch) {
        this.lastPageNumber = this.pageNumber;
      }
      if (value != this.searchString) {
        //if in case searched something that is new than previous search
        this.lastSearchString = this.searchString;
        this.lastSearchPageNumber = 1;
        this.searchString = value;

      } else {
        //if in case searched something that is the same as pervious one
        this.pageNumber = this.lastSearchPageNumber;
      }
      this.pageNumber = this.lastSearchPageNumber;

      this.getNoGvkeyConfirmationRecords(value);
      this.isLastActionSearch = true;
    }
  }


  onPaginateChange(event: PageEvent) {

    if (event.pageSize != this.pageSize) {
      this.selection.clear();
    }

    if (!this.isSearchingIssuerName) {
      //if search removed and paginating
      this.pageNumber = event.pageIndex + 1;
      this.lastPageNumber = this.pageNumber;
      this.pageSize = event.pageSize;
      this.getNoGvkeyConfirmationRecords();
      // console.log('onPaginateChange: event', event);

    } else {
      //if searched something and paginating
      this.pageNumber = event.pageIndex + 1;
      this.lastSearchPageNumber = this.pageNumber;
      this.pageSize = event.pageSize;
      this.getNoGvkeyConfirmationRecords(this.searchString);
      // console.log('search onPaginateChange: event', event);
    }
  }
}
